module.exports = __webpack_public_path__ + "static/media/joseph-nguyen.d1bc1dfc.jpg";